import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  radioWrapper: {
    display: 'grid',
    gridGap: theme.spacing(2),
  },
}));
